import { c as _c } from "react/compiler-runtime";
import type { KeenSliderOptions } from 'keen-slider/react';
import { useKeenSlider } from 'keen-slider/react';
import { useEffect, useState } from 'react';
import { type CarouselProps } from './CarouselProps';
export function useCarouselHandlers(args) {
  const $ = _c(43);
  const {
    initialSlide: t0,
    slides,
    slidesPerView: t1,
    autoSlide: t2,
    autoSlideInterval: t3,
    overflowDesktop,
    overflowMobile: t4,
    numberOfSlidesMoving: t5,
    alignmentDesktop: t6,
    alignmentMobile: t7,
    slideSpacing: t8,
    animationDuration: t9
  } = args;
  const initialSlide = t0 === undefined ? 0 : t0;
  const slidesPerView = t1 === undefined ? 3 : t1;
  const autoSlide = t2 === undefined ? false : t2;
  const autoSlideInterval = t3 === undefined ? 2000 : t3;
  const overflowMobile = t4 === undefined ? true : t4;
  const numberOfSlidesMoving = t5 === undefined ? 3 : t5;
  const alignmentDesktop = t6 === undefined ? "center" : t6;
  const alignmentMobile = t7 === undefined ? "center" : t7;
  const slideSpacing = t8 === undefined ? 40 : t8;
  const animationDuration = t9 === undefined ? 1000 : t9;
  const [currentSlide, setCurrentSlide] = useState(initialSlide);
  const [isLoaded, setLoaded] = useState(false);
  const slideCount = typeof window !== "undefined" && window?.innerWidth <= 720 ? 3 : slidesPerView;
  const t10 = overflowDesktop ? slideCount - 1 : slideCount;
  let t11;
  if ($[0] !== alignmentDesktop || $[1] !== slideSpacing || $[2] !== t10) {
    t11 = {
      perView: t10,
      spacing: slideSpacing,
      origin: alignmentDesktop
    };
    $[0] = alignmentDesktop;
    $[1] = slideSpacing;
    $[2] = t10;
    $[3] = t11;
  } else {
    t11 = $[3];
  }
  let t12;
  if ($[4] !== animationDuration) {
    t12 = {
      duration: animationDuration
    };
    $[4] = animationDuration;
    $[5] = t12;
  } else {
    t12 = $[5];
  }
  let t13;
  if ($[6] !== alignmentMobile || $[7] !== initialSlide || $[8] !== overflowMobile || $[9] !== t11 || $[10] !== t12) {
    const t14 = overflowMobile ? 2 : 1;
    let t15;
    if ($[12] !== alignmentMobile || $[13] !== t14) {
      t15 = {
        "(max-width: 768px)": {
          slides: {
            perView: t14,
            spacing: 25,
            origin: alignmentMobile
          }
        }
      };
      $[12] = alignmentMobile;
      $[13] = t14;
      $[14] = t15;
    } else {
      t15 = $[14];
    }
    t13 = {
      initial: initialSlide,
      slides: t11,
      loop: true,
      defaultAnimation: t12,
      slideChanged(slider) {
        setCurrentSlide(slider.track.details.rel);
      },
      created() {
        setLoaded(true);
      },
      breakpoints: t15
    };
    $[6] = alignmentMobile;
    $[7] = initialSlide;
    $[8] = overflowMobile;
    $[9] = t11;
    $[10] = t12;
    $[11] = t13;
  } else {
    t13 = $[11];
  }
  const keenSliderOptions = t13;
  let t14;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = [];
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  const [sliderRef, instanceRef] = useKeenSlider(keenSliderOptions, t14);
  let t15;
  let t16;
  if ($[16] !== autoSlide || $[17] !== autoSlideInterval || $[18] !== instanceRef) {
    t15 = () => {
      if (!autoSlide || !instanceRef.current) {
        return;
      }
      let timeout;
      let mouseOver = false;
      const clearNextTimeout = function clearNextTimeout() {
        clearTimeout(timeout);
      };
      const nextTimeout = function nextTimeout() {
        clearTimeout(timeout);
        if (mouseOver) {
          return;
        }
        timeout = setTimeout(() => {
          instanceRef?.current?.next();
        }, autoSlideInterval);
      };
      instanceRef?.current?.container.addEventListener("mouseover", () => {
        mouseOver = true;
        clearNextTimeout();
      });
      instanceRef?.current?.container.addEventListener("mouseout", () => {
        mouseOver = false;
        nextTimeout();
      });
      nextTimeout();
      instanceRef?.current?.on("dragStarted", clearNextTimeout);
      instanceRef?.current?.on("animationEnded", nextTimeout);
      instanceRef?.current?.on("updated", nextTimeout);
    };
    t16 = [autoSlide, autoSlideInterval, instanceRef];
    $[16] = autoSlide;
    $[17] = autoSlideInterval;
    $[18] = instanceRef;
    $[19] = t15;
    $[20] = t16;
  } else {
    t15 = $[19];
    t16 = $[20];
  }
  useEffect(t15, t16);
  let t17;
  if ($[21] !== currentSlide || $[22] !== instanceRef || $[23] !== numberOfSlidesMoving || $[24] !== slides) {
    t17 = function previousSlide() {
      const newIndex = (currentSlide - numberOfSlidesMoving + slides.length) % slides.length;
      instanceRef.current?.moveToIdx(newIndex);
    };
    $[21] = currentSlide;
    $[22] = instanceRef;
    $[23] = numberOfSlidesMoving;
    $[24] = slides;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  const previousSlide = t17;
  let t18;
  if ($[26] !== currentSlide || $[27] !== instanceRef || $[28] !== numberOfSlidesMoving || $[29] !== slides) {
    t18 = function nextSlide() {
      const newIndex_0 = (currentSlide + numberOfSlidesMoving) % slides.length;
      instanceRef.current?.moveToIdx(newIndex_0);
    };
    $[26] = currentSlide;
    $[27] = instanceRef;
    $[28] = numberOfSlidesMoving;
    $[29] = slides;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  const nextSlide = t18;
  let t19;
  if ($[31] !== nextSlide || $[32] !== previousSlide) {
    t19 = function moveOnKeyPress(event) {
      if (event.keyCode === 37) {
        previousSlide();
      } else {
        if (event.keyCode === 39) {
          nextSlide();
        }
      }
    };
    $[31] = nextSlide;
    $[32] = previousSlide;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  const moveOnKeyPress = t19;
  let t20;
  if ($[34] !== currentSlide || $[35] !== instanceRef || $[36] !== isLoaded || $[37] !== keenSliderOptions || $[38] !== moveOnKeyPress || $[39] !== nextSlide || $[40] !== previousSlide || $[41] !== sliderRef) {
    t20 = {
      sliderRef,
      moveOnKeyPress,
      isLoaded,
      instanceRef,
      previousSlide,
      nextSlide,
      currentSlide,
      keenSliderOptions
    };
    $[34] = currentSlide;
    $[35] = instanceRef;
    $[36] = isLoaded;
    $[37] = keenSliderOptions;
    $[38] = moveOnKeyPress;
    $[39] = nextSlide;
    $[40] = previousSlide;
    $[41] = sliderRef;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  return t20;
}